import { render, staticRenderFns } from "./Vacation.vue?vue&type=template&id=1610a506&scoped=true"
import script from "./Vacation.vue?vue&type=script&lang=js"
export * from "./Vacation.vue?vue&type=script&lang=js"
import style0 from "./Vacation.vue?vue&type=style&index=0&id=1610a506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1610a506",
  null
  
)

export default component.exports